<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建创意</el-button>
        </li>
        <li>
          <el-button v-if="auditPower" type="primary" size="small" @click="doUpdateDeliveryStatusBatch(true)">批量启投</el-button>
        </li>
        <li>
          <el-button v-if="auditPower" type="primary" size="small" @click="doUpdateDeliveryStatusBatch(false)">批量禁投</el-button>
        </li>
        <li>
          <el-button v-if="deletePower" type="primary" size="small" @click="setDelete">批量删除</el-button>
        </li>
        <li v-if="isSspUser">
          <span>所属广告主：</span>
          <el-select size="small" v-model="queryUser" @change="myOption.restStartPage();setUserId();">
            <el-option v-for="(item, index) in userData" :label="item.advertiserName" :value="item.advertiserId" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>创意名称：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryIdeaName" @input="getList"></el-input>
        </li>
        <li>
          <span>投放计划：</span>
          <el-select size="small" v-model="queryPlan" @change="setPlan()">
            <el-option v-for="(item, index) in planData" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>投放单元：</span>
          <el-select size="small" v-model="queryUnit" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in unitData" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>审核状态：</span>
          <el-select size="small" v-model="queryAuditStatus" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in auditStatus" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>投放状态：</span>
          <el-select size="small" v-model="queryDeliveryStatus" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in deliveryStatus" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%" @selection-change="setSelectionData">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="ListMain-table-expand">
              <el-form-item label="投放单元ID">
                <span>{{ props.row.putUnitInfo.putUnitId }}</span>
              </el-form-item>
              <el-form-item label="投放单元名称">
                <span>{{ props.row.putUnitInfo.putUnitName }}</span>
              </el-form-item>
              <el-form-item label="创意类型ID">
                <span>{{ props.row.ideaTypeInfo.ideaTypeId }}</span>
              </el-form-item>
              <el-form-item label="创意类型名称">
                <span>{{ props.row.ideaTypeInfo.ideaTypeName }}</span>
              </el-form-item>
              <template v-if="props.row.strategyInfo?true:false">
                <el-form-item label="生效时间">
                  <span>{{ props.row.strategyInfo.effectTime }}</span>
                </el-form-item>
                <el-form-item label="过期时间">
                  <span>{{ props.row.strategyInfo.expiredTime }}</span>
                </el-form-item>
                <el-form-item label="前台显示概率">
                  <span>{{ props.row.strategyInfo.showRatio }}</span>
                </el-form-item>
                <el-form-item label="执行时间">
                  <span>{{ props.row.strategyInfo.executeTime }}</span>
                </el-form-item>
                <el-form-item label="执行时间占比">
                  <span>{{ props.row.strategyInfo.executeRatio }}</span>
                </el-form-item>
                <el-form-item label="拉活触发策略">
                  <span>{{ props.row.strategyInfo.triggerWay }}</span>
                </el-form-item>
                <el-form-item label="定时触发策略">
                  <span>{{ props.row.strategyInfo.timeWay }}</span>
                </el-form-item>
                <el-form-item label="定速">
                  <span>{{ props.row.strategyInfo.speedTimes }}</span>
                </el-form-item>
                <el-form-item label="时间段随机">
                  <span>{{ props.row.strategyInfo.timeBucket }}</span>
                </el-form-item>
              </template>
              <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="最后修改时间">
                <span>{{ props.row.updateTime }}</span>
              </el-form-item>
              <el-form-item label="修改人">
                <span>{{ props.row.modifier }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="ideaId" label="ID" min-width="100px"></el-table-column>
        <el-table-column prop="ideaName" label="创意名称" min-width="200px"></el-table-column>
        <el-table-column prop="bidTypeText" label="出价类型" min-width="100px"></el-table-column>
        <el-table-column prop="simulateBid" label="目标出价" min-width="100px"></el-table-column>
        <el-table-column prop="dayShowNum" label="每日最大展示数" min-width="160px"></el-table-column>
        <el-table-column prop="dayClickNum" label="每日最大点击数" min-width="160px"></el-table-column>
        <el-table-column prop="auditStatusText" label="审核状态" min-width="100px">
          <template slot-scope="scope">
            <el-tag size="small" v-if="scope.row.verifyStatus === 0">{{scope.row.auditStatusText}}</el-tag>
            <el-tag size="small" type="success" v-if="scope.row.verifyStatus === 1">{{scope.row.auditStatusText}}</el-tag>
            <el-tag size="small" type="warning" v-if="scope.row.verifyStatus === 2">{{scope.row.auditStatusText}}</el-tag>
            <el-tag size="small" type="info" v-if="scope.row.verifyStatus === 3">{{scope.row.auditStatusText}}</el-tag>
            <el-tooltip v-if="scope.row.auditStatusReason" class="item" effect="dark" placement="top-start" :content="scope.row.auditStatusReason" >
              <div style="font-size: 11px;">原因: {{ $utils.truncate(scope.row.auditStatusReason, 5) }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="投放状态" min-width="100px">
          <template slot-scope="scope">
            <el-switch v-model="tableData[scope.$index].status" :disabled="scope.row.verifyStatus !== 1" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="doUpdateDeliveryStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="400px">
          <template slot-scope="scope">
            <el-button v-if="addPower" type="text" size="small" style="color:#67C23A;" @click="setAddAndModify(tableData[scope.$index], true)">复制</el-button>
            <el-button type="text" size="small" @click="navTo(scope.row, false, 'view', `/home/idea/detail?id=${scope.row.ideaId}`)">查看</el-button>
            <el-button v-if="isSspUser" type="text" size="small" @click="openChangeListDialog(scope.row)">变更记录</el-button>
            <el-button v-if="modifyPower && (scope.row.verifyStatus !== 3)" type="text" size="small" @click="setAddAndModify(scope.row)">修改</el-button>
            <el-button v-if="isSspUser && auditPower && (scope.row.verifyStatus === 0)" type="text" size="small" @click="setAddAndModify(scope.row, false, 'audit')">审核</el-button>
            <el-button v-if="isSspUser && auditPower && (scope.row.verifyStatus !== 3)" type="text" size="small" style="color: orange" @click="doBan(scope.row, true)">封禁</el-button>
            <el-button v-if="isSspUser && auditPower && (scope.row.verifyStatus === 3)" type="text" size="small" style="color: orange" @click="doBan(scope.row, false)">解封</el-button>
            <el-button v-if="deletePower && scope.row.allowDelete" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
            <el-button v-if="(scope.row.bidType === 2 || scope.row.bidType === 3)" type="text" size="small" @click="openConversionSyncDialog(scope.row)">后效数据回传</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="变更记录" :visible.sync="showChangeListDialog" width="1110px">
        <el-table :data="changeList" height="50vh">
          <el-table-column prop="applyType" label="源自" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.applyType === 1" type="success">修改创意</el-tag>
              <el-tag v-else-if="scope.row.applyType === 2" type="danger">修改投放状态</el-tag>
              <el-tag v-else type="info">未知</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建人" width="160">
            <template slot-scope="scope">
              <div>
                <div>{{scope.row.creator}}</div>
                <div style="color: #ccc;font-size: 13px">{{scope.row.createTime}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="提交人" width="160">
            <template slot-scope="scope">
              <div>
                <div>{{scope.row.modifier}}</div>
                <div style="color: #ccc;font-size: 13px">{{scope.row.updateTime}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ideaName" label="创意名称" width="260"></el-table-column>
          <el-table-column prop="simulateBid" label="目标出价" width="80"></el-table-column>
          <el-table-column prop="auditStatusText" label="审核状态" width="100"></el-table-column>
          <el-table-column prop="status" label="投放状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success">开启</el-tag>
              <el-tag v-if="scope.row.status !== 1" type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openChangeDetailDialog(scope.row)">变更详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <el-dialog title="变更详情" :visible.sync="showChangeDetailDialog" v-if="showChangeDetailDialog" :fullscreen="true">
        <DetailTemplate referer="apply" :id="applyId" :object="apply"></DetailTemplate>
      </el-dialog>

      <el-dialog title="后效数据回传接口地址" :visible.sync="showConversionSyncDialog" width="800px">
        <el-row>
          <el-col :span="24">{{conversionSyncUrl}}<i class="el-icon-document-copy" style="margin-left: 5px;cursor: pointer" @click="copyClipboard(conversionSyncUrl)"></i></el-col>
        </el-row>
      </el-dialog>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
import ideaAPI from '../../api/idea'
import DetailTemplate from './DetailTemplate'
export default {
  name: 'List',
  components: {
    DetailTemplate,
    Pagination
  },
  data () {
    return {
      isSspUser: this.$store.getters.isMediaOwner,
      isLoading: true,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      statusPower: false,
      auditPower: false,
      queryAuditStatus: '',
      queryDeliveryStatus: '',
      queryUser: this.$route.params.advertiserId || '',
      userData: [],
      queryIdeaName: '',
      queryUnit: this.$route.params.unitId || '',
      unitData: this.myOption.selectAll,
      queryPlan: this.$route.params.planId || '',
      planData: this.myOption.selectAll,
      selectionData: [],
      auditStatus: [
        {id: '', name: '不限'},
        {id: 0, name: '审核中'},
        {id: 1, name: '审核通过'},
        {id: 2, name: '审核未通过'},
        {id: 3, name: '封禁'}
      ],
      deliveryStatus: [
        {id: '', name: '不限'},
        {id: 1, name: '开启'},
        {id: 0, name: '关闭'}
      ],
      showChangeListDialog: false,
      changeList: [],
      showChangeDetailDialog: false,
      applyId: '',
      apply: {},
      showConversionSyncDialog: false,
      conversionSyncUrl: ''
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.idea.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      let power = powers[700].powerValue
      // 新建
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
      // 启用/禁用
      if ((power & thisModule.status.power) === thisModule.status.power) {
        this.statusPower = true
      }
      // 审核
      if ((power & thisModule.audit.power) === thisModule.audit.power) {
        this.auditPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 获取缓存筛选数据
    this.myOption.getScreenData(this, 'screen-idea')
    // 判断是否为媒体主
    if (this.isSspUser) {
      this.getAdOwnerList().then(() => {
        this.getPlanList().then(() => {
          if (this.queryUnit) {
            this.getUnitList().then(() => {
              this.getList()
            })
          } else {
            this.getList()
          }
        })
      })
    } else {
      this.getPlanList().then(() => {
        if (this.queryUnit) {
          this.getUnitList().then(() => {
            this.getList()
          })
        } else {
          this.getList()
        }
      })
    }
  },
  methods: {
    // 获取广告主列表
    getAdOwnerList () {
      return new Promise((resolve) => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.list.id
          },
          url: this.myOption.requestUrl + this.thisModule.list.user,
          data: this.qs.stringify({
            startPage: 1,
            pageSize: this.myOption.pageSize.max
          })
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            this.userData = res.data.data.data
            this.myOption.appendSelectAllItem('advertiser', this.userData)
            if (this.$route.path.indexOf('/list') > -1 && !this.queryUser) {
              try {
                this.queryUser = this.userData[0].advertiserId
                resolve && resolve()
              } catch (e) {
                this.isLoading = false
              }
            } else {
              resolve && resolve()
            }
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      })
    },
    // 获取投放计划列表
    getPlanList () {
      return new Promise((resolve) => {
        let param = {
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        }
        if (this.isSspUser) {
          param.advertiserId = this.queryUser
        }
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.list.id
          },
          url: this.myOption.requestUrl + this.thisModule.list.plan,
          data: this.qs.stringify(param)
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            let newData = []
            for (var val of res.data.data.data) {
              newData.push({id: val.planId, name: val.planName})
            }
            this.planData = [...this.myOption.selectAll, ...newData]
            resolve && resolve()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      })
    },
    // 获取投放单元列表
    getUnitList () {
      return new Promise((resolve) => {
        let param = {
          startPage: 1,
          pageSize: this.myOption.pageSize.max,
          planId: this.queryPlan
        }
        if (this.isSspUser) {
          param.advertiserId = this.queryUser
        }
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.list.id
          },
          url: this.myOption.requestUrl + this.thisModule.list.unit,
          data: this.qs.stringify(param)
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            let newData = []
            for (var val of res.data.data.data) {
              newData.push({id: val.putUnitId, name: val.putUnitName})
            }
            this.unitData = [...this.myOption.selectAll, ...newData]
            resolve && resolve()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      })
    },
    // 获取列表
    getList () {
      let param = {
        ideaName: this.queryIdeaName,
        verifyStatus: this.queryAuditStatus,
        status: this.queryDeliveryStatus,
        startPage: this.$store.state.user.currentPage,
        pageSize: this.$store.state.user.pageSize,
        planId: this.queryPlan,
        putUnitId: this.queryUnit
      }
      if (this.isSspUser) {
        param.advertiserId = this.queryUser
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify(param)
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            val.slotType = this.myOption.getIdData('slotType', val.slotType, 'name')
            val.bidTypeText = this.myOption.getIdData('bidType', val.bidType, 'name')
            if (val.strategyInfo) {
              val.strategyInfo.triggerWay = this.myOption.getIdData('triggerWay', val.strategyInfo.triggerWay, 'name')
              val.strategyInfo.timeWay = this.myOption.getIdData('timeWay', val.strategyInfo.timeWay, 'name')
              val.strategyInfo.effectTime = this.myOption.writeCurrentDate(val.strategyInfo.effectTime)
              val.strategyInfo.expiredTime = this.myOption.writeCurrentDate(val.strategyInfo.expiredTime)
              let executeTimeArr = val.strategyInfo.executeTime.split(',')
              let executeTime = []
              for (let key in executeTimeArr) {
                let time = parseInt(executeTimeArr[key])
                let h = parseInt(time / 3600)
                let m = parseInt((time - h * 3600) / 60)
                let s = time - h * 3600 - m * 60
                executeTime.push(`${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`)
              }
              val.strategyInfo.executeTime = executeTime.join(',')
            }

            val.auditStatusText = (this.auditStatus.find(item => item.id === val.verifyStatus) || {}).name
            val.auditStatusReason = val.verifyStatus === 2 ? val.verifyFailReason || '' : (val.verifyStatus === 3 ? val.disabledReason || '' : '')
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    stash (data, isCopy, mode) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.ideaId, copy: isCopy || false, mode: mode})
      }
      let param = {}
      if (this.queryUser !== '') {
        param.queryUser = this.queryUser
      }
      if (this.queryIdeaName !== '') {
        param.queryIdeaName = this.queryIdeaName
      }
      if (this.queryPlan !== '') {
        param.queryPlan = this.queryPlan
      }
      if (this.queryUnit !== '') {
        param.queryUnit = this.queryUnit
      }
      if (this.queryAuditStatus !== '') {
        param.verifyStatus = this.queryAuditStatus
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-idea', JSON.stringify(param))
      }
    },
    // 新增和修改
    setAddAndModify (data, isCopy, mode) {
      this.stash(data, isCopy, mode)
      this.myOption.switchListAndEdit(this, false)
    },
    navTo (data, isCopy, mode, to) {
      this.stash(data, isCopy, mode)
      this.myOption.navigateTo(this, to)
    },
    openChangeDetailDialog (apply) {
      this.applyId = apply.ideaApplyId
      this.apply = apply
      this.showChangeDetailDialog = true
    },
    openConversionSyncDialog (data) {
      this.showConversionSyncDialog = true
      this.conversionSyncUrl = data.dataSyncUrl
    },
    copyClipboard (conversionSyncUrl) {
      this.$utils.copyToClipboard(conversionSyncUrl, (err) => {
        if (err) {
          console.log(err)
          this.$message.error('复制失败')
        } else {
          this.$message.success('复制成功')
        }
      })
    },
    // 删除
    setDelete (param) {
      if (!param.ideaName && this.selectionData.length === 0) {
        return false
      }
      this.$confirm(`是否${param.ideaName ? '' : '批量'}删除${param.ideaName ? (' "' + param.ideaName + '" ') : ''}创意`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ideaIds = ''
        if (param.ideaName) {
          ideaIds = `${param.ideaId}`
        } else {
          let arr = []
          for (var val of this.selectionData) {
            arr.push(val.ideaId)
          }
          ideaIds = arr.join(',')
        }
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            ideaIds: ideaIds
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除创意成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    },
    // 启用/禁用批量
    doUpdateDeliveryStatusBatch (ble) {
      if (this.selectionData.length === 0) {
        return false
      }
      this.$confirm(`是否批量${ble ? '启' : '禁'}投`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          status: ble * 1
        }
        let arr = []
        for (var val of this.selectionData) {
          arr.push(val.ideaId)
        }
        param.ideaId = arr.join(',')
        this.doUpdateDeliveryStatus(param)
      }).catch(() => {})
    },
    openChangeListDialog (entity) {
      this.ideaId = entity.ideaId
      ideaAPI.getChangeList({
        startPage: 1,
        pageSize: 9999999,
        ideaId: this.ideaId
      }).then(res => {
        this.changeList = res.data.data
        for (let val of this.changeList) {
          val.auditStatusText = (this.auditStatus.find(item => item.id === val.verifyStatus) || {}).name
        }
        this.showChangeListDialog = true
      })
    },
    viewChangeApply (entity) {

    },
    doBan (entity, isBan) {
      this.$prompt('是否确定？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入原因',
        // inputPattern: /.*/,
        inputValidator: (value) => {
          // if (isBan && !value) {
          //   return '请输入原因'
          // }
          return true
        },
        inputErrorMessage: '请输入原因'
      }).then(({value}) => {
        ideaAPI.updateBanStatus({
          ideaId: entity.ideaId,
          disabled: isBan,
          disabledReason: isBan ? value : ''
        }).then(res => {
          this.$message.success(`操作成功`)
          this.getList()
        })
      })
    },
    doUpdateDeliveryStatus (params) {
      ideaAPI.updateDeliveryStatus({
        ideaId: params.ideaId,
        status: params.status
      }).then(res => {
        this.$message.success(`${params.status === 1 ? '开启' : '禁用'}投放`)
        this.getList()
      })
    },
    // 设置投放计划
    setPlan () {
      this.myOption.restStartPage()
      this.queryUnit = ''
      this.unitData = []
      this.getUnitList().then(() => {
        this.getList()
      })
    },
    // 设置批量数据
    setSelectionData (data) {
      this.selectionData = data || []
    },
    // 设置广告主
    setUserId () {
      this.queryPlan = ''
      this.queryUnit = ''
      this.unitData = []
      this.planData = this.myOption.selectAll
      this.unitData = this.myOption.selectAll
      // 调用获取投放计划列表函数
      this.getPlanList().then(() => {
        // 调用获取列表函数
        this.getList()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/idea/List.vue